import React from "react";
import { Box } from "@mui/material";
import {
  userReportByPortalsType,
  userReportType,
} from "../../../../../services/api/types/reports/reports";
import { UserReportTable } from "./UserReportTable";

interface UserReportByPortalsTableProps {
  data: userReportByPortalsType[];
}

export const UserReportByPortalsTable: React.FC<
  UserReportByPortalsTableProps
> = ({ data }) => {
  if (!data || data.length === 0) return null;

  // Helper function to convert userReportByPortals to userReportType format
  const convertToUserReportType = (
    portalData: userReportByPortalsType
  ): userReportType[] => {
    return portalData.users.map((user) => ({
      userUid: user.userUid,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      userAttributes: user.userAttributes,
      name: portalData.name,
      portalUid: portalData.portalUid,
      parentPortalUid: portalData.parentPortalUid,
      registeredAt: user.registeredAt,
    }));
  };

  return (
    <>
      {data.map((portalData) => (
        <Box key={portalData.portalUid} sx={{ mb: 4 }}>
          <UserReportTable
            users={convertToUserReportType(portalData)}
            portalName={portalData.name}
          />
        </Box>
      ))}
    </>
  );
};
